<template>
    <v-container class="partnered-locations">
        <v-expansion-panels
            v-model="panels"
            flat
        >
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>Partners</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <ClButton
                        class="button-update"
                        :disabled="( getInFlight || updateInFlight )"
                        :loading="( getInFlight || updateInFlight )"
                        :rounded="false"
                        @click="updatePartneredLocations()"
                    >
                        Update
                    </ClButton>
                    <ClTableFilterable
                        :items="possiblePartnerList"
                        :filter.sync="table.filter"
                        :headers="table.headers"
                        :selected.sync="table.selected"
                        :itemsPerPage="-1"
                        filterLabel="Filter Locations..."
                        :noDataText="( getInFlight ? 'Getting Possible Partner Locations...' : 'No Possible Partnered Locations Found' )"
                        hideAdd
                        showSelect
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'PartneredLocations',
    data() {
        return {
            panels: [ 0 ],
            table: {
                filter: '',
                selected: [],
                headers: [
                    {
                        text: 'Location Name',
                        value: 'friendly',
                    },
                    {
                        text: 'Street Address',
                        value: 'street1',
                    },
                    {
                        text: 'City',
                        value: 'city',
                    },
                    {
                        text: 'State',
                        value: 'state',
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters( {
            hasWebsiteInfo: 'Website/hasInfo',
        } ),
        ...mapState( {
            getInFlight: ( state ) => state.Inventory.possiblePartners.inFlight,
            updateInFlight: ( state ) => state.Inventory.partneredLocations.inFlight,
            possiblePartnerList: ( state ) => state.Inventory.possiblePartners.list,
        } ),
    },
    watch: {
        hasWebsiteInfo: {
            immediate: true,
            handler: 'getPartneredLocations',
        },
    },
    methods: {
        async getPartneredLocations() {
            await this.$store.dispatch( 'Inventory/getAllPossiblePartners' );
            // Pre-populate the selected locations in the table with those already partnered with this location
            this.table.selected = this.possiblePartnerList.filter( ( location ) => location.partnered );
        },
        async updatePartneredLocations() {
            await this.$store.dispatch( 'Inventory/updatePartneredLocations', {
                partnerList: this.table.selected,
            } );
            await this.getPartneredLocations();
        },
    },
};
</script>

<style scoped lang="scss">
.partnered-locations {
    ::v-deep.v-expansion-panel {
        .v-expansion-panel-header {
            padding: 0;
        }
        .v-expansion-panel-content {
            .v-expansion-panel-content__wrap {
                padding: 0;
            }
        }
    }

    .v-card {
        margin-left: -1rem;
    }

    .button-update {
        margin-top: .5rem;
        margin-bottom: .5rem;
        width: 100%;
    }
}
@include mixins-above(tablet) {
    .partnered-locations {
        .button-update {
            width: auto;
        }
    }
}
</style>
